<formstep-detail :options="options" :editable="true" :model="programm"></formstep-detail>